import { useCallback, useMemo } from "react"

import { DocumentForm } from "@l2r-front/l2r-app-doc"
import { useTranslation } from "@l2r-front/l2r-i18n"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useRiskZoneUpdateDocument } from "../../hooks/mutations/useRiskZoneUpdate"
import { useRiskZoneCluster } from "../../hooks/queries/useRiskZoneClusters"

export const RiskZoneAddDocumentForm = (props) => {
    const {
        riskZoneId,
        onClose,
        onSubmitting,
        onChange,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const { data } = useRiskZoneCluster(riskZoneId)

    const riskZone = useMemo(() => {
        if (data) {
            return data.find(zone => zone.risk_zone.identifier == riskZoneId)
        }
        return null
    }, [data, riskZoneId])

    const mutation = useRiskZoneUpdateDocument(riskZone?.uuid, {}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.riskZoneDocumentEditForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "containers.riskZoneDocumentEditForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: (error) => {
            onSubmitting(false)
            console.error("Error updating risk zone document:", error)
        },
    })

    const onSubmit = useCallback((formValues) => {
        const values = {
            document: formValues,
        }
        mutation.mutate(values)
        onSubmitting(true)
    }, [mutation, onSubmitting])

    return <DocumentForm
        isSubmitting={mutation.isPending}
        onSubmit={onSubmit}
        onCancel={() => onClose()}
        onChange={onChange}
    />
}